webpackJsonp([238395832385168],{

/***/ 1722:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ConversationPage","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"entries","type":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"Conversation","ofType":null}}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"metadata","type":{"kind":"OBJECT","name":"Cursor","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-conversation-page-408b75f3e7a5be076fb3.js